const staticConfig = {
  credits: {
    enabled: false,
  },
  accessibility: {
    enabled: false,
  },
  chart: {
    type: 'heatmap',
    marginTop: 20,
    marginBottom: 100,
    plotBorderWidth: 0,
  },
  colorAxis: {
    min: 0,
    stops: [],
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        format: '{point.formattedValue}',
        style: {
          textOutline: 'none',
        },
      },
    },
  },

  tooltip: {
    shared: false,
    hideDelay: 50,
    snap: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'var(--neutral-border)',
  },

  legend: {
    align: 'center',
    layout: 'horizontal',
    verticalAlign: 'bottom',
    y: 20,
    symbolHeight: 25,
  },
};

export default class DefaultHeatmapChartConfig {
  declare config: Highcharts.Options;

  constructor() {
    this.config = {
      ...structuredClone(staticConfig),
      chart: { type: 'heatmap' },
    } as Highcharts.Options;
  }
}
